var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13C6.3866 13.3866 7.0134 13.3866 7.4 13C7.7866 12.6134 7.7866 11.9866 7.4 11.6L3.8 8H15C15.5523 8 16 7.55228 16 7C16 6.44771 15.5523 6 15 6H3.8L7.4 2.4C7.7866 2.0134 7.7866 1.3866 7.4 0.999999C7.0134 0.6134 6.3866 0.6134 6 1L0.707107 6.29289C0.316583 6.68342 0.316583 7.31658 0.707107 7.70711L6 13Z",
    fill: "#96b000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.20b456564109b4ef147f631a95925f5c.svg";
export { ForwardRef as ReactComponent };